import * as Yup from "yup";
import { withFormik } from "formik";

const checkoutSubscriptionEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    firstName: Yup.string().required("Please enter firstname"),
    lastName: Yup.string().required("Please enter last name"),
    // country: Yup.string().required("Please enter country"),
    address_line1: Yup.string().required("Please enter unit"),
    address_line2: Yup.string().required("Please enter street address"),
    city: Yup.string()
      .required("Please enter city")
      .matches("^[A-Z a-z]+$", "Please enter valid city"),
    state: Yup.string()
      .required("Please enter province")
      .matches("^[A-Z a-z]+$", "Please enter valid state"),
    postal_code: Yup.string()
      .required("Please enter postal_code")
      .matches("^[0-9]+$", "Please enter valid postal code")
      .max(10, "Postal code must be atmost 10 characters in length"),

    cardname: Yup.string().when("existingCard", {
      is: value => (value === "new" ? true : false),
      then: () =>
        Yup.string()
          .required("Please enter card name")
          .matches("^[A-Z a-z]+$", "Please enter valid card name")
          .min(
            2,
            "Card name length should be of atleast 2 characters in length"
          )
          .max(
            26,
            "Card name length should be of atmost 2 characters in length"
          )
          .trim(),
      otherwise: () => Yup.string()
    }),
    cardnumber: Yup.string().when("existingCard", {
      is: value => (value === "new" ? true : false),
      then: () =>
        Yup.string()
          .min(19, "Card Number must be at least 16 characters")
          .max(19, "Card Number must be at least 16 characters")
          .matches(/^[0-9 ]*$/, "Please enter valid card number")
          .trim()
          .required("Please enter card number"),
      otherwise: () => Yup.string()
    }),
    expirydate: Yup.string().when("existingCard", {
      is: value => (value === "new" ? true : false),
      then: () => Yup.string().required("Please enter expiry date"),
      otherwise: () => Yup.string().nullable()
    }),
    cvc: Yup.string().when("existingCard", {
      is: value => (value === "new" ? true : false),
      then: () =>
        Yup.string()
          .required("Please enter cvv")
          .matches(/^\d+$/, "Enter valid cvv ")
          .max(3, "Cvv must be atleast 3 numbers")
          .min(3, "Cvv must be atleast 3 numbers"),
      otherwise: () => Yup.string()
    }),
    email: Yup.string().required("Please enter email"),
    existingCard: Yup.string().required("Please enter existing card")
  }),
  mapPropsToValues: props => ({
    firstName: "",
    lastName: "",
    // country: "",
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    cardnumber: "",
    expirydate: "",
    cvc: "",
    postal_code: "",
    email: "",
    cardname: "",
    existingCard: "",
    customer_id: ""
  }),
  validateOnMount: true,
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});
export default checkoutSubscriptionEnhancer;
